define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_deposit/validate_form/asia_banks",

        validation: {
            mt4_account_no: {
                required: true,
            },
            currency_abbr: {
                required: true,
            },
            amount: {
                required: true,
                pattern: 'number'
            },
        },

        labels:{
            amount: "Amount",
            currency_abbr: "Currency"
        }
    });
});
